import { GenericSingleDateFilter } from '@app/core/list-view/base-filters/GenericSingleDateFilter';
import {
  parseAsSingleDateFilter,
  type SingleDateFilterValue,
} from '@app/core/list-view/helpers/parse-as-single-date-filter';
import { singleDateFilterValueToIsoRange } from '@app/core/list-view/helpers/single-date-filter-value-to-range';
import { createFilter } from '@app/core/list-view/types';

export const YOUTUBE_CUEPOINTS_FILTERS_CONFIG = [
  createFilter({
    name: 'targetDate',
    label: false,
    parser: parseAsSingleDateFilter.withDefault({ presetId: 'today' }),
    isPermanent: true,
    component: GenericSingleDateFilter,
    componentProps: {},
    toApi: (val: SingleDateFilterValue, context) => {
      const { from, to } = singleDateFilterValueToIsoRange(
        val,
        (context?.timezone as string | undefined) ?? 'UTC',
      );

      if (!from || !to) {
        return null;
      }

      return [`createdAt||$between||${from},${to}`];
    },
  }),
];
